module.exports = __webpack_public_path__ + "static/img/2.3b228cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/2.png
// module id = p9Q4
// module chunks = 0